<template>
	<div>
		<van-form>
			<van-field v-model="form.user_name" name="请假人" label="请假人" readonly />
			<van-field v-model="form.process_name" name="请假流程" label="请假流程" readonly />
			<van-field v-model="typeList[form.type]" name="请假类型" label="请假类型" readonly />
			<van-field v-model="form.start_date" name="请假日期" label="开始日期" readonly />
			<van-field v-model="form.end_date" name="请假日期" label="结束日期" readonly />
			<van-field v-model="form.day" name="请假天数" label="请假天数" readonly />
			<van-field v-model="form.cause" rows="3" autosize label="请假事由" type="textarea" readonly />
		</van-form>
	</div>
</template>

<script>
export default {
	name: "leave",
	props: {
		rform: Object
	},
	data() {
		return {
			form: {},
			typeList: [
				"年假",
				"事假",
				"病假",
				"调休假",
				"婚假",
				"产假",
				"陪产假",
				"其他"
			]
		};
	},
	watch: {
		rform: {
			immediate: true,
			handler(newV) {
				this.form = newV;
			}
		}
	}
};
</script>